module.exports = __webpack_public_path__ + "img/xacobeo-on.06f9d1c3.png";